import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Switzerland",
  "use": "icon-Switzerland-usage",
  "viewBox": "0 0 1536 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1536 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-Switzerland\"><path d=\"M0 0h1536v1024H0z\" fill=\"#E94B35\" p-id=\"2697\" /><path d=\"M672 224h192v576H672z\" fill=\"#FFFFFF\" p-id=\"2698\" /><path d=\"M480 416h576v192H480z\" fill=\"#FFFFFF\" p-id=\"2699\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol